export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/typographic.e980dfc.svg";